
import { Component, inject, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { HeaderComponent } from '@components/dashboard/header/header.component';
import { NavComponent } from '@components/dashboard/navigation/nav.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DashboardService } from '@services/dashboard.service';
import { LocalService } from '@services/local.service';
import { Ad } from '@interfaces/models.interface'
import { NgbModal,NgbAlertModule, NgbDatepickerModule, NgbDateStruct, NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';
import {Router, RouterModule} from '@angular/router';
import { MomentModule } from 'ngx-moment';
import { Apollo, gql } from 'apollo-angular';
import { CREATE_ADS_MUTATION, UPDATE_ADS_MUTATION } from '@gql_queries/ads/mutations';
import { ADS_LIST } from '@gql_queries/ads/queries';
import { AuthStore } from '@store/auth.store';
import { QuillModule } from 'ngx-quill';
import { DownloadHandlerUtil } from '@shared/utils/download-handler-util';


@Component({
    selector: 'app-dashboard-ads-manage',
    standalone: true,
    templateUrl: './dashboard-ads-manage.component.html',
    styleUrl: './dashboard-ads-manage.component.css',
    imports: [NgbDatepickerModule, NgbAlertModule, HeaderComponent, NavComponent, CommonModule, FormsModule, NgbTimepickerModule, RouterModule, MomentModule, QuillModule],
})
export class DashboardAdsManageComponent {
  today = new Date();
  imageSrc?: string | ArrayBuffer | null;
  model?: NgbDateStruct = { year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: this.today.getDate() };
  time = { hour: 0, minute: 0 };
	meridian = false;

  constructor(
      private router: Router,
      private dasher: DashboardService,
      private localservice: LocalService,
      private apollo: Apollo,
      private authStore: AuthStore,
      private downloadHandler: DownloadHandlerUtil
  ) { }

  private modalService = inject(NgbModal);
  @ViewChild('successModal') successModalRef!: TemplateRef<any>;
  public successMessage: string = '';
  public adsList: Ad[] = [];

  public searchKeyword: string = '';
  public currentSelectedPageList: Ad[] = [];
  public maxPages: number = 0;
  public disableActionBtns: any = {
      next: false,
      prev: false,
  };
  public adPages: number[] = [];
  public currentPage: number = 1;
  public pageSize: number = 15;

  public detailViewed: Record<string, any> = {};
  public showDetails: boolean = false;
  public adFormNew: Record<string, any> = {
    title: '',
    subTitle: '',
    description: '',
    photo: '',
    link: '',
    status: '',
    publishedDate: '',
    audience: 'all',
    isSponsor: false,
    sponsor: ''
  }
  public newAdPublishToggle: boolean = false;
  adPhoto: File | null = null;

  public enableEdit: boolean = false;
  public pendingPublishStatus: string = 'published';
  public detailIsSponsor: boolean = false;

  quillModules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      ['blockquote', 'code-block'],
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'indent': '-1' }, { 'indent': '+1' }],
      [{ 'direction': 'rtl' }],
      [{ 'size': ['small', false, 'large', 'huge'] }],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'script': 'sub' }, { 'script': 'super' }],
      [{ 'align': [] }],
      ['link'],
      ['clean']
    ]
  };

  ngOnInit(): void {
    this.fetchAds('all');
  }

  downloadAdsReport(): void {
    this.downloadHandler.downloadReport('ads', {
      data: this.currentSelectedPageList,
      fileName: 'ads-report',
    });
  }

  fetchAds(status:string, action: string = ''){
      var fromPage = 1;
      if(action != ''){
        fromPage = this.currentPage;
        switch(action){
            case 'next':
                this.currentPage++
            break;

            case 'prev':
                if(this.currentPage != 1){
                    this.currentPage--
                }//end if
            break;
        }//end swithc
      }//end if

      this.apollo
      .watchQuery({
          fetchPolicy: 'network-only',
          query: ADS_LIST,
          variables: {
              "page": this.currentPage,
              "audience": "all",
              "status": status
          }
      }).valueChanges.subscribe({
        next: (res: any) => {
          if(action != ''){
              if(res.data['ads']?.length != 0){
                  this.adsList = [];
                  this.adsList = res.data['ads'];
                  this.currentSelectedPageList = this.adsList;
              }else{
                  this.currentPage = fromPage;
              }
          }else{
              this.adsList = [];
              this.adsList = res.data['ads'];
              this.currentSelectedPageList = this.adsList;
          }
        },
        error: (error) => {
          if (error.message === 'Unauthorized' || error?.networkError?.status === 403) {
              this.authStore.logout().subscribe(() => {
                  this.router.navigate(['/admin/login']);
              });
          }
        }
      });
  }//end fn

  nextPrev(action: string){
    switch(action){
        case 'next':
            this.fetchAds('all' , 'next');
        break;

        case 'prev':
            this.fetchAds('all' , 'prev');
        break;
    }//end swithc
}//end fn


searchData(event: Event) {
  const inputElement = event.target as HTMLInputElement;
  this.searchKeyword = inputElement.value;

  if (this.searchKeyword.trim() === '') {
      console.log('Input is empty');
      this.currentSelectedPageList = this.adsList;
  } else {
      this.currentSelectedPageList = this.adsList.filter(object => {
          // Helper function to recursively search through nested objects
          const searchInObject = (obj: any): boolean => {
              for (const key in obj) {
                  const value = obj[key];

                  // Skip if null or undefined`
                  if (value == null) continue;

                  // If value is an object or array, search recursively
                  if (typeof value === 'object') {
                      if (searchInObject(value)) return true;
                  }
                  // Check if the value includes the search term
                  else if (value.toString().toLowerCase().includes(this.searchKeyword.toLowerCase())) {
                      return true;
                  }
              }
              return false;
          };

          return searchInObject(object);
      });
  }
}//end nfn

viewDetails(details: Ad){
    this.showDetails = true;
    this.detailViewed = details;
    this.detailIsSponsor = !!details.isSponsor;
    console.log(details);
}//end fn

returnToList(){
    this.showDetails = false;
    this.detailViewed = {};
    this.detailIsSponsor = false;

    this.currentPage = 1;
    this.currentSelectedPageList = this.adsList;
}//end fn

showCreateAdForm(modal: TemplateRef<any>){
  this.modalService.open(modal,{ size: 'lg',  backdrop: 'static', keyboard: false });
}//end fn

createNewAd(status: string, confirmModal: TemplateRef <any>){
  let pubdate = this.model?.year + '-' + ((this.model!.month.toString().length > 1) ? this.model!.month: '0'+this.model!.month) + '-' + ((this.model!.day.toString().length > 1) ? this.model!.day: '0'+this.model!.day);
  let pubtime = ((this.time.hour.toString().length > 1) ? this.time.hour: '0'+this.time.hour) + ':' + ((this.time.minute.toString().length > 1) ? this.time.minute: '0'+this.time.minute)+ ':00';
  this.adFormNew['publishedDate'] = pubdate + ' ' + pubtime;

  if(status == 'draft'){
    this.adFormNew['status'] = status;
  }else{
    if(this.newAdPublishToggle){
      this.adFormNew['status'] = 'published';
    }else{
      this.adFormNew['status'] = 'unpublished';
    }//end fn
  }//end if

  var errors: number = 0;
  Object.keys(this.adFormNew).forEach((x) => {
    if(x != 'photo' && x != 'isSponsor' && x != 'sponsor'){
      if(this.adFormNew[x] == ''){
        console.log(x + ' is empty');
        errors ++;
      }//end if
    }//end if
  });

  if(errors != 0){
    alert('Please enter all required fields');
  }else{
    this.modalService.open(confirmModal, { size: 'md',  backdrop: 'static', keyboard: false });
  }//end if
}//end fn

onFileSelected(event: any): void {
  const file: File = event.target.files[0];
  if (file) {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.imageSrc = e.target.result;
    };
    reader.readAsDataURL(file);
    this.adPhoto = file;
  }//end
}//end fn

closeAllModals(){
  this.modalService.dismissAll();
}//end fn

showSuccessModal(message: string){
  this.successMessage = message;
  this.modalService.open(this.successModalRef, { size: 'md', backdrop: 'static', keyboard: false });
}//end fn

proceedCreateAds(){
  const formData:any = new FormData();
  if (this.adPhoto) {
    formData.append('file', this.adPhoto, this.adPhoto.name);
  }

  this.dasher.uploadPhoto(formData, 'ads_photo').subscribe((res: any) => {
    this.adFormNew['photo'] = res.photo;
    this.apollo.mutate({
        mutation: CREATE_ADS_MUTATION,
        variables: {
          createAdsInput: this.adFormNew
        }
    }).subscribe({
        next: ({ data }: any) => {
          if(data['createAds']?.length != 0){
            this.currentPage = 1;
            this.adsList = [data['createAds'], ...this.adsList];
            this.maxPages = this.localservice.getTotalPages(this.adsList, this.pageSize);
            this.adPages = Array.from({ length: this.maxPages}, (_, i) => i + 1);
            this.currentSelectedPageList = this.localservice.paginateData(this.adsList, this.currentPage, this.pageSize)

            if(this.maxPages == 1){
                this.disableActionBtns.next = true;
                this.disableActionBtns.prev = true;
            }else{
                this.disableActionBtns.next = false;
                this.disableActionBtns.prev = true;
            }//end if

            this.modalService.dismissAll();

            Object.keys(this.adFormNew).forEach((x) => {
              this.adFormNew[x] = '';
            });

            this.imageSrc = null;
            this.adPhoto = null;
            this.showSuccessModal('Ad successfully created');
          }
        },
        error: (error) => {
            if (error.message === 'Unauthorized' || error?.networkError?.status === 403) {
                this.authStore.logout().subscribe(() => {
                    // Optional: Redirect to login page or show message
                    this.router.navigate(['/admin/login']);
                });
            }
        }
    });
  });
}//end fn

enableEditForm(){
  this.enableEdit = true;
}//end fn

disableEditForm(){
  this.enableEdit = false;
}//end fn

openPublishModal(modal: TemplateRef<any>, status: string){
  this.pendingPublishStatus = status;
  this.modalService.open(modal, { size: 'md', backdrop: 'static', keyboard: false });
}//end fn

publishThisAd(){
  this.modalService.dismissAll();
  const newStatus = this.pendingPublishStatus;
  const updateInput = {
    audience: this.detailViewed['audience'],
    description: this.detailViewed['description'],
    isSponsor: this.detailIsSponsor,
    link: this.detailViewed['link'],
    photo: this.detailViewed['photo'],
    publishedDate: this.detailViewed['publishedDate'],
    sponsor: this.detailViewed['sponsor'],
    status: newStatus,
    subTitle: this.detailViewed['subTitle'],
    title: this.detailViewed['title']
  };
  this.apollo.mutate({
      mutation: UPDATE_ADS_MUTATION,
      variables: {
          adsId: this.detailViewed['adsId'],
          updateAdsInput: updateInput
      }
  }).subscribe({
      next: ({ data }: any) => {
          if(data['updateAds']){
              this.detailViewed = { ...this.detailViewed, status: newStatus };
              this.adsList = this.adsList.map((ad: any) =>
                  ad.adsId === this.detailViewed['adsId'] ? { ...ad, status: newStatus } : ad
              );
              this.currentSelectedPageList = [...this.adsList];
              this.showSuccessModal('Ad ' + newStatus + ' successfully');
          }
      },
      error: (error) => {
          if (error.message === 'Unauthorized' || error?.networkError?.status === 403) {
              this.authStore.logout().subscribe(() => {
                  this.router.navigate(['/admin/login']);
              });
          }
      }
  });
}//end fn

updateThisDetails(){
  const updateInput: Record<string, any> = {
    audience: this.detailViewed['audience'],
    description: this.detailViewed['description'],
    isSponsor: this.detailIsSponsor,
    link: this.detailViewed['link'],
    photo: this.detailViewed['photo'],
    publishedDate: this.detailViewed['publishedDate'],
    sponsor: this.detailViewed['sponsor'],
    status: this.detailViewed['status'],
    subTitle: this.detailViewed['subTitle'],
    title: this.detailViewed['title']
  };

  const formData:any = new FormData();
  if (this.adPhoto) {
      formData.append('file', this.adPhoto, this.adPhoto.name);
      this.dasher.uploadPhoto(formData, 'ads_photo').subscribe((res: any) => {
          updateInput['photo'] = res.photo;
          this.submitUpdateAds(updateInput);
      });
  }else{
      this.submitUpdateAds(updateInput);
  }//end if
}//end fn

submitUpdateAds(updateInput: Record<string, any>){
  this.apollo.mutate({
      mutation: UPDATE_ADS_MUTATION,
      variables: {
          adsId: this.detailViewed['adsId'],
          updateAdsInput: updateInput
      }
  }).subscribe({
      next: ({ data }: any) => {
          if(data['updateAds']){
              this.disableEditForm();
              this.adPhoto = null;
              this.showSuccessModal('Ad successfully updated');
          }
      },
      error: (error) => {
          if (error.message === 'Unauthorized' || error?.networkError?.status === 403) {
              this.authStore.logout().subscribe(() => {
                  this.router.navigate(['/admin/login']);
              });
          }
      }
  });
}//end fn
}
